document.addEventListener("DOMContentLoaded", () => {
    const allImageSequencer = document.querySelectorAll("[component-type='ImageSequencer']")
    allImageSequencer.forEach(component => {
        initImageSequencer(component)
    })
})

/**
 * @param {HTMLDivElement} component 
 */
async function initImageSequencer(component) {
    console.log({ ImageSequencer: component })
    const waitCount = component.dataset.waitCount ?? 5
    const imgTags = component.querySelectorAll("img")

    for (const [i, imgTag] of imgTags.entries()) {
        if (!imgTag.getAttribute("src") && imgTag.dataset.src) {
            imgTag.src = imgTag.dataset.src

            if ((i + 1) % waitCount === 0) {
                await new Promise((resolve, reject) => {
                    // console.log("[ImageSequencer]", i, imgTag.complete, imgTag.loading)
                    if (imgTag.complete || imgTag.loading == "lazy") {
                        requestAnimationFrame(() => resolve())
                        return
                    }
                    imgTag.addEventListener("load", resolve)
                    imgTag.addEventListener("error", reject)
                }).catch(err => {
                    console.log("[ImageSequencer]", imgTag.src, err)
                })
            }
        }
    }

}